import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { compose } from 'redux';
import _ from 'underscore';
import { toSentenceSerial } from 'underscore.string';
import { Locales } from '../../strings/Locales.js';
export var Arrays = /*#__PURE__*/ function() {
    "use strict";
    function Arrays() {
        _class_call_check(this, Arrays);
    }
    Arrays.sortByString = function sortByString(array) {
        return _.sortBy(array, function(str) {
            return str;
        });
    };
    // Return 0 if arrays are equal, 1 if array1 is greater than array2, -1 otherwise.
    Arrays.compare = function compare(array1, array2) {
        var value = 0;
        var i = 0;
        while(array1[i] === array2[i] && i < array1.length){
            i++;
        }
        if (array1[i] > array2[i]) {
            value = 1;
        } else if (array1[i] < array2[i]) {
            value = -1;
        }
        return value;
    };
    Arrays.enumerate = function enumerate(items) {
        return _.isEmpty(items) ? '' : toSentenceSerial(items, ', ', " ".concat(Locales.format('and'), " "));
    };
    return Arrays;
}();
Arrays.swapIfEmpty = function(array1, array2) {
    return _.isEmpty(array1) ? array2 : array1;
};
export var ArraysOfObjects = function ArraysOfObjects() {
    "use strict";
    _class_call_check(this, ArraysOfObjects);
};
ArraysOfObjects.sortObjectKeys = function(obj) {
    return _.isObject(obj) ? Object.keys(obj).sort().reduce(function(acc, key) {
        return _object_spread_props(_object_spread({}, acc), _define_property({}, key, obj[key]));
    }, {}) : {};
};
ArraysOfObjects.toObject = function(list) {
    return _.indexBy(list, function(item) {
        return hash(JSON.stringify(ArraysOfObjects.sortObjectKeys(item)));
    });
};
/**
     * Returns the objects in the first list that are not in the second list or any of the other lists
     */ ArraysOfObjects.difference = function(first, second) {
    for(var _len = arguments.length, others = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        others[_key - 2] = arguments[_key];
    }
    var difference_recursive = function difference_recursive(list1, list2) {
        var __chain;
        var hashedList1 = ArraysOfObjects.toObject(list1);
        var hashedList2 = ArraysOfObjects.toObject(list2);
        return (__chain = _.chain(hashedList1)).omit.apply(__chain, _to_consumable_array(_.keys(hashedList2))).values().value();
    };
    return _.reduce(others, function(memo, list) {
        return difference_recursive(memo, list);
    }, difference_recursive(first, second));
};
ArraysOfObjects.intersection = function(first, second) {
    for(var _len = arguments.length, others = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        others[_key - 2] = arguments[_key];
    }
    var intersection_recursive = function intersection_recursive(list1, list2) {
        var __chain;
        var hashedList1 = ArraysOfObjects.toObject(list1);
        var hashedList2 = ArraysOfObjects.toObject(list2);
        return (__chain = _.chain(hashedList1)).pick.apply(__chain, _to_consumable_array(_.keys(hashedList2))).values().value();
    };
    return _.reduce(others, function(memo, list) {
        return intersection_recursive(memo, list);
    }, intersection_recursive(first, second));
};
ArraysOfObjects.uniq = function(list) {
    return _.values(ArraysOfObjects.toObject(list));
};
ArraysOfObjects.union = function() {
    for(var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++){
        lists[_key] = arguments[_key];
    }
    return compose(ArraysOfObjects.uniq, _.compact, _.flatten)(lists);
};
/**
 * Hash a given string to a unique hash value
 * Took from https://jsperf.com/hashing-strings
 */ var hash = function hash(str) {
    var res = 0;
    for(var i = 0; i < str.length; i++){
        res = res * 31 + str.charCodeAt(i);
        /* eslint-disable-next-line no-bitwise */ res = res & res;
    }
    return res;
};

//# sourceMappingURL=ArraysUtils.js.map